/**
 * ProfessocialNetworkContent stellt initial die Weiche für die verschiedenen Socialnetworks
 */

import React, { useEffect, useState } from 'react'

import { NetworkContentConfiguration } from '@professocial/professocialTypes/types/configurationTypes'

import * as commonActions from '../store/common/common.actions'

import FacebookContent from './subScreens/FacebookContent'
import { useDispatch, useSelector } from 'react-redux'
import InstagramContent from './subScreens/InstagramContent'
import GoogleMyBusinessContent from './subScreens/GoogleMyBusinessContent'
import { StyledEngineProvider } from '@mui/styled-engine'
import { CssBaseline } from '@mui/material'
import { NetworkType } from '@3m5/sm_publish-frontend-api'
import SettingsInstagramConnect
  from '@professocial/professocialCore/src/screens/Settings/subScreens/SettingsInstagramConnect'
import { SocialmediaConnection } from '@professocialApi/professocial-core-frontend-api/models'
import { getUser } from '@professocial/professocialCore/src/store/common/common.selectors'
import LinkedInContent from './subScreens/LinkedInContent'

export interface Props {
  networkContentConfiguration?: NetworkContentConfiguration
}

const ProfessocialNetworkContent: React.FC<Props> = (props) => {
  const dispatch = useDispatch()

  const storedFacebookPageId: string | null = window.localStorage.getItem('facebookPageNetworkId')
  const storedInstagramPageId: string | null = window.localStorage.getItem('instagramPageNetworkId')
  const storedLinkedInPageId: string | null = window.localStorage.getItem('linkedInPageNetworkId')
  const storedGoogleMyBusinessPageId: string | null = window.localStorage.getItem('googleMyBusinessPageNetworkId')

  useEffect(() => {
    props.networkContentConfiguration?.generalOptions && dispatch(commonActions.setGeneralOptions(props.networkContentConfiguration?.generalOptions))
  }, [props.networkContentConfiguration?.generalOptions],
  )

  useEffect(() => {
    props.networkContentConfiguration?.theme && dispatch(commonActions.setTheme(props.networkContentConfiguration?.theme))
  }, [props.networkContentConfiguration?.theme],
  )


  // Todo googleID noch raus nehmen
  return (
    <StyledEngineProvider injectFirst>
      <CssBaseline />
      {props.networkContentConfiguration?.networkType === NetworkType.Facebook && storedFacebookPageId &&
        <FacebookContent networkPageId={storedFacebookPageId || ''} />}

      {props.networkContentConfiguration?.networkType === NetworkType.Instagram && storedInstagramPageId &&
        <InstagramContent networkPageId={storedInstagramPageId || ''} />}

      {props.networkContentConfiguration?.networkType === NetworkType.LinkedIn && storedLinkedInPageId &&
        <LinkedInContent networkPageId={storedLinkedInPageId || ''} networkContentConfiguration={props.networkContentConfiguration} />}

      {props.networkContentConfiguration?.networkType === NetworkType.GoogleMyBusiness && storedGoogleMyBusinessPageId &&
        <GoogleMyBusinessContent
          networkPageId={storedGoogleMyBusinessPageId || ''}
          networkUserId={'108608735063156457156'}
        />}
    </StyledEngineProvider>
  )
}
export default ProfessocialNetworkContent
